export default __webpack_public_path__ + "static/okremote_3-f23d15660c0a2af431302aecd6636282.jpg";